import React from 'react'
import styles from './styles.css'

interface TitleProps {
  title: string
  subTitle?: string | null
}

const Title: React.SFC<TitleProps> = ({ title, subTitle }) => {
  return (
    <>
      <h1 className={styles.title}>{title}</h1>
      {subTitle && <h2 className={styles.subTitle}>{subTitle}</h2>}
    </>
  )
}

export default Title
